/* eslint-disable arrow-body-style */
/* eslint-disable one-var */
export const getShopByID = state => id => state.shops.all.find(shop => shop.id === id);

export const getTotalBranchCount = state => state.shops.all.reduce((acc, val) => acc + val.amount, 0);
